import { ExternalLink } from "@/components/ExternalLink";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import i18n from "@/i18n";
import { formatNumber } from "@/features/Table/utils";
import { parseDate } from "@/lib/utils";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";
import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";
import { createEnum } from "@/lib/utils/createEnum";

// import { getAuditColumns } from "@/features/Audit/getAuditColumns";

export type C5TimeSerie = {
  id: number;
  date: string;
  c5_static_datum_name: string;
  c5_static_datum_id?: number;

  fixing: number;
  market_value: number;
  devise: string;
  currency?: string;
};
const c5TimeSerieFields = createEnum<C5TimeSerie>();

const tableName = Tables.C5_TIME_SERIES;
const t = (key: string, defaultValue: string) =>
  i18n.t(`${tableName}.columns.${key}`, { ns: "tables", defaultValue });

export const columns: ColumnDef<C5TimeSerie>[] = [
  {
    accessorKey: c5TimeSerieFields.id,
    header: t("id", "ID"),
  },
  {
    accessorKey: c5TimeSerieFields.date,
    header: t("date", "Date"),
    cell: ({ row }) => {
      return parseDate(row.getValue(c5TimeSerieFields.date));
    },
  },
  {
    accessorKey: c5TimeSerieFields.c5_static_datum_name,
    header: t("c5_static_datum_name", "Asset"),
    cell: ({ row }) => {
      return (
        <ExternalLink
          href={toWorkspacePath(
            `/admin/${Clients.C5}/${Tables.C5_STATIC_DATA}/${row.original.c5_static_datum_id}`,
          )}
          className="text-xs lg:whitespace-nowrap"
          underline="hover"
        >
          {row.getValue(c5TimeSerieFields.c5_static_datum_name)}
        </ExternalLink>
      );
    },
  },
  {
    accessorKey: c5TimeSerieFields.fixing,
    header: () => <div className="text-right">{t("fixing", "Fixing")}</div>,
    cell: ({ row }) => {
      const value = row.getValue(c5TimeSerieFields.fixing) as number;
      const formattedValue =
        value === null || value === undefined || Number.isNaN(value)
          ? ""
          : new Intl.NumberFormat("en-US", {
              minimumFractionDigits: 5,
              maximumFractionDigits: 5,
            }).format(value);

      return <div className="text-right">{formattedValue}</div>;
    },
  },
  {
    accessorKey: c5TimeSerieFields.market_value,
    header: () => (
      <div className="text-right">{t("market_value", "Market value")}</div>
    ),
    cell: ({ row }) => {
      return (
        <div className="text-right">
          {formatNumber(row.getValue(c5TimeSerieFields.market_value))}
        </div>
      );
    },
  },
  {
    accessorKey: c5TimeSerieFields.currency,
    header: t("currency", "Currency"),
  },
  {
    id: "actions",
    header: () => <div className="text-right">{t("actions", "Actions")}</div>,
    cell: ({ row }) => {
      return (
        <div className="flex justify-end">
          <Link
            href={`${window.location.pathname}/${row.getValue(c5TimeSerieFields.id)}`}
            className="text-xs"
            underline="hover"
          >
            {i18n.t("actions.edit")}
          </Link>
        </div>
      );
    },
  },
];
